// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goals-list-page__page-title[data-v-6efb3758]{font-size:24px;font-weight:bold}.goals-list-page__create-category-button[data-v-6efb3758]{font-size:18px;margin-bottom:10px;display:inline-block}\n", ""]);
// Exports
module.exports = exports;
